var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeAppBar'),(_vm.project)?_c('div',{staticClass:"project-content"},[_c('ProjectBanner',{attrs:{"project":_vm.project}}),_c('ProjectTabs',{attrs:{"project":_vm.project}}),_c('ProjectComments',{attrs:{"comments":_vm.project.comments}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }